import { Module } from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import CookiesState from '../types/CookiesState';

export const cookiesStore: Module<CookiesState, any> = {
  namespaced: true,
  state: {
    cookieConsent: null
  },
  actions,
  mutations,
  getters
};
